
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus, Ticket } from "lucide-react";

interface EmptyTicketStateProps {
  onAdd: () => void;
}

const EmptyTicketState: React.FC<EmptyTicketStateProps> = ({ onAdd }) => {
  return (
    <div className="text-center py-12 bg-white/5 rounded-lg border border-purple-500/20">
      <Ticket className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <h3 className="text-xl font-medium text-white mb-2">No Tickets Found</h3>
      <p className="text-gray-400 mb-6">Get started by adding your first ticket type</p>
      <Button 
        onClick={onAdd}
        className="bg-purple-600 hover:bg-purple-700"
      >
        <Plus className="mr-2 h-4 w-4" /> Add Ticket Type
      </Button>
    </div>
  );
};

export default EmptyTicketState;
